import { Anchor, Button, PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React, { useEffect } from 'react';
import { renderContentBlock } from 'utils';
import { useTranslation } from 'utils/hooks';
import type { RichTextComponent } from 'utils/hooks/useTranslation';

const CookiePolicyPage: NextPage = () => 
{
  const translations = useTranslation();
  const { t } = translations;

  const richComponents: Record<string, RichTextComponent> = {
    googlePrivacySharing: <Anchor href="https://policies.google.com/privacy?hl=de#infosharing" external target="_blank" />,
    microsoftPrivacy: <Anchor href="https://privacy.microsoft.com/de-de/privacystatement" external target="_blank" />,
    microsoftOptOut: <Anchor href="https://choice.microsoft.com/de-DE/opt-out" external target="_blank" />,
    googlePrivacy: <Anchor href="https://policies.google.com/privacy" external target="_blank" />,
    privacyEmail: <Anchor href="mailto:datenschutz@wirtschaft.at" />,
    cookieSettings: <Button onClick={() => (window as any).Cookiebot.show()} />,
    legal: <Anchor href="/datenschutz" />,
    code: <code />,
    cookieList: <div id="CookiebotDeclaration" key='cookieDeclation' />,
  };

  useEffect(() => 
  {
    const cookieBotWrapper = document.getElementById('CookiebotDeclaration');
    if (cookieBotWrapper)
    {
      const script = document.createElement('script');
      script.id = 'CookieDeclaration';
      script.type = 'text/javascript';
      script.async = false;
      script.src = 'https://consent.cookiebot.com/f443fe75-15db-4fe0-b810-94e4de8ea58d/cd.js';

      cookieBotWrapper.innerHTML = '';
      cookieBotWrapper.appendChild(script);

      return () => cookieBotWrapper.innerHTML = '';
    }
    return () => {};
  }, []);

  return (
    <PageLayout textContentPage>

      <Head title={t('cookiePolicy:meta.title')}>
        <meta name="description" content={t('cookiePolicy:meta.description')} />
        <meta name="keywords" content={t('cookiePolicy:meta.keywords')} />
        <meta name="robots" content="noindex" />
      </Head>

      <PageHeading title={t('cookiePolicy:heading')} />

      <p>{t('cookiePolicy:version')}</p>

      <div className="noListStyles">
        <ol>
          {renderContentBlock('cookiePolicy:content', translations, richComponents, 2, 'p')}
        </ol>
      </div>
      
    </PageLayout>
  );
};

export default CookiePolicyPage;

export const getServerSideProps: GetServerSideProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'cookiePolicy');
  
  return { props: { ...translations } };
};
